import React, { useState, useEffect } from 'react';
import './Management.css';
import ManagementTableSkeleton from './Components/ManagementTableSkeleton';
import {
   Table, Space, Tooltip, Button, Select, Input, Row, Col, Tag,
   Modal, Typography, Spin, Popconfirm, Empty, message
} from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import * as AntDIcons from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
const { Text } = Typography;
const SECTION_ALLOWED_CHARACTERS_REGEX = /[^A-Za-z0-9\s\-()[\]/\\|:{}_<>*@#&$.'"`]/g;
const SECTION_ALLOWED_SINGLE_CHARACTER_REGEX = /^[A-Za-z0-9\s\-()[\]/\\|:{}_<>*@#&$.'"`]$/;

export function Sections() {
   const navigate = useNavigate();

   const [searchText, setSearchText] = React.useState("");
   const [searchedColumn, setSearchedColumn] = React.useState("");

   const [sectionList, setSectionList] = useState([]);
   const [searchLoading, setSearchLoading] = useState(false);

   const [updating, setUpdating] = useState(false);
   const [editModalVisible, setEditModalVisible] = useState(false);
   const [addModalVisible, setAddModalVisible] = useState(false);

   const [section, setSection] = useState(null);
   const [sectionDesc, setSectionDesc] = useState(null);

   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   useEffect(() => {
      Utils.verifyJwt();

      // if (user_role.toLowerCase() !== 'admin' && user_role.toLowerCase() !== 'teacher')
      const allowedRoles = ['super admin', 'admin'];
      if (!allowedRoles.includes(user_role.toLowerCase()))
         navigate('/home');

      GetSectionList();
   }, []);

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<AntDIcons.SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button
                  size="small"
                  style={{ width: 90 }}
                  // onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}
                  onClick={() => {
                     handleReset(clearFilters);
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Reset
               </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <AntDIcons.SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const columns = [
      {
         title: '',
         dataIndex: 'id',
         key: 'id',
         hidden: true,
      },
      {
         title: 'Section',
         key: 'section_desc',
         ...getColumnSearchProps('section_desc'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="topLeft" title={payload.section_desc}>
               <Text>
                  {
                     payload.section_desc
                  }
               </Text>
            </Tooltip>
         ),
         width: '85%'
      },
      {
         title: 'Action',
         key: 'action',
         render: payload => {
            return <>
               <Space size="small">
                  <Tooltip placement="top" title='Edit Section'>
                     <AntDIcons.EditOutlined color='#4abec7' style={{ cursor: 'pointer' }} onClick={() => handleEdit(payload.id, payload.section_desc)} />
                  </Tooltip>
                  {/* <Tooltip placement="top" title='Remove Section'>
                     <Popconfirm
                        title="Are you sure you want to remove this section?"
                        onConfirm={() => handleRemove(payload.id)}
                        okText="Yes"
                        cancelText="No"
                     >
                        <AntDIcons.DeleteOutlined color='#4abec7' style={{ cursor: 'pointer' }} />
                     </Popconfirm>
                  </Tooltip> */}
               </Space>
            </>
         },
         width: '15%'
      },
   ].filter(item => !item.hidden);

   const GetSectionList = () => {
      setSearchLoading(true);

      axios.get(`${process.env.REACT_APP_API_MANAGEMENT}/getsectionlist`).then((response) => {
         if (response.data) {
            const data = response.data;

            setSectionList(data);
            setSearchLoading(false);
         }
      }, (error) => {
         setSearchLoading(false);
         console.log(error.message);
      });
   }

   const handleAddNewSection = () => {
      setSectionDesc('');
      setAddModalVisible(true);
   }

   const handleEdit = (id, desc) => {
      setSection(id);
      setSectionDesc(desc || '');
      setEditModalVisible(true);
   }

   const sanitizeSectionDescription = (value) => value.replace(SECTION_ALLOWED_CHARACTERS_REGEX, '');

   const normalizeSectionDescription = (value) => sanitizeSectionDescription(value || '').trim();

   const handleSectionDescriptionChange = (event) => {
      setSectionDesc(sanitizeSectionDescription(event.target.value));
   };

   const handleSectionDescriptionKeyDown = (event) => {
      if (event.ctrlKey || event.metaKey || event.altKey || event.key.length !== 1) {
         return;
      }

      if (!SECTION_ALLOWED_SINGLE_CHARACTER_REGEX.test(event.key)) {
         event.preventDefault();
         message.warning({
            key: 'section-invalid-character',
            // content: 'Only letters, numbers, spaces, and - ( ) [ ] / \\ | : { } _ < > * @ # & are allowed.',
            content: 'That key is not allowed.',
            duration: 1.5,
         });
      }
   };

   const handleSave = () => {
      const normalizedSectionDesc = normalizeSectionDescription(sectionDesc);

      if (normalizedSectionDesc !== '') {
         setUpdating(true);
         setSectionDesc(normalizedSectionDesc);

         axios.post(`${process.env.REACT_APP_API_MANAGEMENT}/createsection`, null, {
            params: {
               newsection: normalizedSectionDesc,
            },
         }).then((response) => {
            if (response.data) {
               const data = response.data;

               GetSectionList();
               setUpdating(false);
               // setEditModalVisible(false);
               // setAddModalVisible(false);

               Modal.success({
                  title: 'Section Management',
                  content: 'Creating new section successful.',
                  centered: true,
                  onOk: () => { handleCancel() },
               });
            }
         }, (error) => {
            setUpdating(false);
            console.log(error.message);
            Modal.error({
               title: 'Section Management',
               content: error.response.data,
               centered: true,
            });
         });
      } else {
         Modal.info({
            content: (
               <>
                  Please complete the folowing before saving:
                  <ul>
                     <li>
                        New Section
                     </li>
                  </ul>
               </>),
            centered: true,
         });
      }

   }

   const handleUpdate = () => {
      const normalizedSectionDesc = normalizeSectionDescription(sectionDesc);

      if (normalizedSectionDesc !== '') {
         setUpdating(true);
         setSectionDesc(normalizedSectionDesc);

         axios.post(`${process.env.REACT_APP_API_MANAGEMENT}/updatesection`, null, {
            params: {
               id: section,
               desc: normalizedSectionDesc,
            },
         }).then((response) => {
            if (response.data) {
               const data = response.data;

               GetSectionList();
               setUpdating(false);
               // setEditModalVisible(false);
               // setAddModalVisible(false);

               Modal.success({
                  title: 'Section Management',
                  content: 'Updating section successful.',
                  centered: true,
                  onOk: () => { handleCancel() },
               });
            }
         }, (error) => {
            setUpdating(false);
            console.log(error.message);
            Modal.error({
               title: 'Section Management',
               content: error.response.data,
               centered: true,
            });
         });

         // GetSectionList();
         // setUpdating(false);
         // setEditModalVisible(false);
         // setAddModalVisible(false);
      } else {
         Modal.info({
            title: 'Student Management',
            content: (
               <>
                  Please complete the folowing before saving:
                  <ul>
                     <li>
                        New Section
                     </li>
                  </ul>
               </>),
            centered: true,
         });
      }
   }

   const handleCancel = () => {
      setSection(null);
      setSectionDesc('');
      setUpdating(false);
      setEditModalVisible(false);
      setAddModalVisible(false);
   }

   const handleRemove = (id) => {
      axios.post(`${process.env.REACT_APP_API_MANAGEMENT}/deletesection?id=${id}`).then((response) => {
         if (response.data) {
            const data = response.data;

            GetSectionList();
            setUpdating(false);
            setEditModalVisible(false);
            setAddModalVisible(false);

            Modal.success({
               title: 'Section Management',
               content: 'Removing section successful.',
               centered: true,
            });
         }
      }, (error) => {
         console.log(error.message);
         Modal.error({
            title: 'Section Management',
            content: error.response.data,
            centered: true,
         });
      });
   }

   return (
      <>
         <div className="dashboard-area-all management-page">
            <div className="dashboard-item management-shell">
               <div className="management-breadcrumb">
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'management', node: 'Management' },
                        { key: 'sections', node: 'Sections' },
                     ]}
                  />
               </div>

               <section className="management-hero">
                  <div>
                     <Text className="management-kicker">Management</Text>
                     <h1>Sections</h1>
                     <p>Organize class sections used for enrollment, assignments, attendance, and reporting.</p>
                     <div className="management-meta">
                        <span><AntDIcons.UnorderedListOutlined /> Section list</span>
                        <span><AntDIcons.DatabaseOutlined /> {searchLoading ? 'Loading records' : `${sectionList.length} records`}</span>
                     </div>
                  </div>
                  <div className="management-actions">
                     <Button className='management-create-btn button-shadow' type="primary" size="large" shape='round' onClick={() => handleAddNewSection()}>
                        <AntDIcons.PlusOutlined /> Add New Section
                     </Button>
                  </div>
               </section>

               <section className="management-panel">
                  <div className="management-table-shell">
                     {
                        searchLoading
                           ?
                           <ManagementTableSkeleton />
                           :
                           (sectionList.length > 0 && !searchLoading)
                              ?
                              <Table
                                 className="management-table"
                                 rowKey={'uid'}
                                 // loading={searchLoading}
                                 size='small'
                                 columns={columns}
                                 dataSource={sectionList}
                                 pagination={false}
                                 scroll={{
                                    y: 'calc(100svh - 12rem)',
                                    x: '1000px'
                                 }}
                                 footer={() => <div className="management-table-footer"><span>Total Records: {sectionList.length}</span></div>}
                              />
                              :
                              <div className='management-empty-state'>
                                 <Empty image="../images/brainee_mascot.png" description="No records found" />
                              </div>
                     }

                  </div>
               </section>
            </div>
         </div>

         {/* Modals */}
         <Modal
            className="management-modal"
            title={"Add New Section"}
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancel(); }}
            onOk={() => { handleSave() }}
            open={addModalVisible}
            width='35%'
            style={{ minWidth: '300px' }}
            okButtonProps={{ shape: 'round' }}
            cancelButtonProps={{ shape: 'round' }}
            okText={'Save'}
         // footer={null}
         >
            <Input
               allowClear
               size='large'
               style={{ borderRadius: 7 }}
               placeholder="Enter New Section"
               value={sectionDesc ?? ''}
               onChange={handleSectionDescriptionChange}
               onKeyDown={handleSectionDescriptionKeyDown}
            />
         </Modal>

         <Modal
            className="management-modal"
            title={"Edit Section"}
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancel(); }}
            onOk={() => { handleUpdate() }}
            open={editModalVisible}
            width='35%'
            style={{ minWidth: '300px' }}
            okButtonProps={{ shape: 'round' }}
            cancelButtonProps={{ shape: 'round' }}
            okText={'Update'}
         // footer={null}
         >
            <Spin spinning={updating} tip={"Processing, please wait..."}>
               <Input
                  allowClear
                  size='large'
                  style={{ borderRadius: 7 }}
                  value={sectionDesc ?? ''}
                  onChange={handleSectionDescriptionChange}
                  onKeyDown={handleSectionDescriptionKeyDown}
               />
            </Spin>
         </Modal>
      </>
   );
}
